module.exports = __webpack_public_path__ + "static/media/sobha.516d46d7.png";